/**
 * BrochureLangMenu — trilingual sales-brochure download picker.
 *
 * Renders a trigger button (caller passes its own styling so the menu
 * blends into any page) that opens a 3-language dropdown:
 * English / العربية / Oʻzbekcha. Each item opens the on-demand PDF
 * endpoint in a new tab.
 */
import React from 'react';
import { FileDown, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LANGS = [
  { code: 'en', label: 'English', hint: 'EN' },
  { code: 'ar', label: 'العربية', hint: 'AR' },
  { code: 'uz', label: 'Oʻzbekcha', hint: 'UZ' },
];

export const BrochureLangMenu = ({
  label = 'Download Brochure',
  className = '',
  testId = 'download-brochure',
  iconSize = 14,
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button type="button" data-testid={testId} className={className}>
        <FileDown size={iconSize} /> {label} <ChevronDown size={Math.max(iconSize - 3, 10)} />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="min-w-[190px]">
      {LANGS.map((l) => (
        <DropdownMenuItem
          key={l.code}
          data-testid={`${testId}-${l.code}`}
          className="cursor-pointer gap-2"
          onClick={() =>
            window.open(
              `${BACKEND_URL}/api/brochure/download.pdf?lang=${l.code}`,
              '_blank',
              'noopener'
            )
          }
        >
          <span className="font-semibold">{l.label}</span>
          <span className="ml-auto text-[10px] uppercase tracking-[0.18em] text-slate-400">
            {l.hint} · PDF
          </span>
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);

export default BrochureLangMenu;
